<template lang="pug">
.card.text-left(v-if="usuario")
	.card-header
		span.fa.fa-user.mr-2
		| {{usuario.nombre}} {{usuario.apellidos}}
		button.close(v-if="!card" @click="cerrar") &times;
	.card-body.text-center
		img(:src="usuario.avatar", class="rounded-circle", style="width:200px;height:200px;")
		p
			h3
				| Acumuladas
				br
				b {{horas.acumula}} horas
		p
			h3
				| Consumidas
				br
				b {{horas.consume}} horas
	.card-body.bg-light.text-center
		h3(v-if="horas.resto !== 0")
			span(v-if="horas.resto < 0")
				| Debe
				br
				| {{horas.resto * (-1)}} horas
			span(v-else)
				| {{horas.resto}} horas
				br
				span para consumir
		h3(v-else) Nada pendiente
</template>

<script>
import API from '../api'
export default {
	props: ['idUsuario', 'card'],
	data () {
		return {
			usuario: null,
			horas: {}
		}
	},
	created () {
		API.infoUsuario(this.idUsuario)
			.then(res => {
				this.usuario = res.data.usuario
				this.horas = res.data.horas
			})
			.catch(e => {
				this.cerrar()
				this.$store.commit('toast/danger', {
					titulo: 'Error',
					mensaje: e.response.data.error
				})
			})
	},
	methods: {
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/gestion-horaria/vue/common/detalle.vue